import { connect } from 'dva'
import Page, { CustomPageProps } from '../../../../Components/Page'

const AuthBaseLayoutPage: React.FC<CustomPageProps> = ({
  dispatch,
  header,
  children,
  ...props
}) => {
  return (
    <Page ignoreHeaderDivider header={header} {...props}>
      {children}
    </Page>
  )
}

export default connect()(AuthBaseLayoutPage)
